import * as React from 'react';
export function VerticalSlideshow(_a) {
    var urls = _a.urls;
    var _b = React.useState(0), offset = _b[0], updateOffset = _b[1];
    // Animation loop.
    React.useEffect(function () {
        setTimeout(function () {
            updateOffset(offset - 1);
        }, 25);
    }, [offset]);
    var slides = urls
        .concat(urls)
        .concat(urls)
        .concat(urls)
        .concat(urls)
        .concat(urls)
        .concat(urls)
        .concat(urls);
    return (React.createElement("div", { className: 'netset-vertical-slideshow-container' },
        React.createElement("div", { className: 'netset-slideshow-track', style: { transform: "translate(0px, ".concat(offset, "px)") } }, slides.map(function (url, i) {
            return React.createElement("div", { key: i, className: 'netset-slideshow-image-container' },
                React.createElement("img", { src: url, loading: 'eager', alt: 'Decorative image.' }));
        }))));
}
